import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h2 class=\"headline headline-content\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":3,"column":38},"end":{"line":3,"column":52}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n<div class=\"row\">\r\n  <div class=\"card-layout mlo-content hide\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mloItems") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":32,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"zipCodeText") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":4},"end":{"line":60,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n<div class=\"row non-mlo-content\">\r\n  <div class=\"card-layout\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"each","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":4},"end":{"line":77,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n</div>\r\n<p class=\"hide\">\r\n  <a id=\"get_a_call_back_engagement\" href=\"javascript:void(0);\" class=\"spa-ui-layer-link spa-fn-done\"\r\n    rel=\"get_a_call_back_modal_layer\" data-options=\"{&quot;rel&quot;:&quot;get_a_call_back_modal_layer&quot;}\">Get a\r\n    call back<span class=\"spa-ada-text ada-hidden\">&nbsp;layer</span></a>\r\n</p>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"content-block outter-card\">\r\n      <div class=\"card\">\r\n        <div class=\"mlo-override\">\r\n          <p class=\"headline-med\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":10,"column":34},"end":{"line":10,"column":45}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"address") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":10},"end":{"line":13,"column":17}}})) != null ? stack1 : "")
    + "          <p class=\"content\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":14,"column":29},"end":{"line":14,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"img") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":10},"end":{"line":28,"column":17}}})) != null ? stack1 : "")
    + "        </div>\r\n      </div>\r\n    </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "          <p class=\"address\"><span class=\"address-line-one\"></span>&nbsp;<span class=\"address-line-two\"></span><span class=\"city\"></span> <span class=\"state\"></span></p>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"\">\r\n              <div class=\"photoURL\"></div>\r\n              <div class=\"name\">\r\n                <span class=\"firstName\"></span> <span class=\"lastName\"></span>\r\n              </div>\r\n              <div class=\"nml\">\r\n                NMLS ID: <span class=\"nmlSID\"></span>\r\n              </div>\r\n              <div class=\"phone-number\">\r\n                <a class=\"number call-us\" id=\"phone_number_2\" href=\"tel:"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"numberActual") || (depth0 != null ? lookupProperty(depth0,"numberActual") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"numberActual","hash":{},"data":data,"loc":{"start":{"line":25,"column":72},"end":{"line":25,"column":88}}}) : helper)))
    + "\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"number") || (depth0 != null ? lookupProperty(depth0,"number") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"number","hash":{},"data":data,"loc":{"start":{"line":25,"column":90},"end":{"line":25,"column":100}}}) : helper)))
    + "</a>\r\n              </div>\r\n            </div>\r\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "   <div class=\"content-block outter-card\">\r\n      <div class=\"card\">\r\n    <div class=\"mlo-lending\">\r\n      <div class=\"mlo-content-heading\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"zipCodeText") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n      <div class=\"mlo-content-subheading\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"zipCodeText") : depth0)) != null ? lookupProperty(stack1,"subheading") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n      <div style=\"display:flex\">\r\n        <div class=\"spa-input spa-input-box spa-input--sparta2 has-help\">\r\n          <label class=\"spa-input-label\"\r\n            for=\"location-input\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"zipCodeText") : depth0)) != null ? lookupProperty(stack1,"placeholder") : stack1), depth0)) != null ? stack1 : "")
    + "</label>\r\n          <input id=\"location-input\" class=\"spa-input mlo-input\" type=\"text\">\r\n        </div>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"language") : depths[1]),"==","en",{"name":"compare","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":9},"end":{"line":50,"column":20}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"language") : depths[1]),"==","es",{"name":"compare","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":51,"column":8},"end":{"line":55,"column":20}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n    </div>\r\n    </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"go-btn\">\r\n          <a id=\"locationNLEnglish\" href=\"javascript:void(0)\"\r\n            class=\"go-trigger spa-btn spa-btn--small spa-btn--primary\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"zipCodeText") : depth0)) != null ? lookupProperty(stack1,"goButton") : stack1), depth0)) != null ? stack1 : "")
    + "</a>\r\n        </div>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"go-btn\">\r\n          <div class=\"go-btn\"> "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"zipCodeText") : depth0)) != null ? lookupProperty(stack1,"goButton") : stack1), depth0)) != null ? stack1 : "")
    + " </div>\r\n        </div>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"content-block outter-card\">\r\n      <div class=\"card\">\r\n        <div class=\"medium-centered\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"img") : depth0),{"name":"with","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":69,"column":8},"end":{"line":71,"column":17}}})) != null ? stack1 : "")
    + "          <p class=\"headline-med\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":72,"column":34},"end":{"line":72,"column":45}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n          <p class=\"content\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":73,"column":29},"end":{"line":73,"column":42}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <img id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" class=\"img "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"CLASS") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":70,"column":45},"end":{"line":70,"column":79}}})) != null ? stack1 : "")
    + "\" alt=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"alt") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":70,"column":86},"end":{"line":70,"column":121}}})) != null ? stack1 : "")
    + "\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"src") : depth0), depth0))
    + "\" aria-hidden=\"true\" />\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"CLASS") : depth0), depth0));
},"16":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"scope") : stack1), depth0))
    + " is-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"language") || (depth0 != null ? lookupProperty(depth0,"language") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"language","hash":{},"data":data,"loc":{"start":{"line":1,"column":32},"end":{"line":1,"column":44}}}) : helper)))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":86,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/contact-us-module",
  "version": "1.0.5",
  "id": "contactUsModule",
  "containerID": "homeLoansContactUsModule",
  "moduleName": "home-loans-contact-us-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "contactUsModule",
  "data": {
    "init": "contactUsModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "scope",
    "type": "string",
    "default": "",
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0"
  },
  "stores": []
};

/*
 * contact-us-module
 * module_js_id: contactUsModuleJS
 *
 * Copyright (c) 2016-6-23
 */

/**
 * @export
 * @class contactUsModule
 * @extends {Module}
 */
class contactUsModule extends Module {
  /**
   * Constructor for module JS.
   * @param {Object} options module opts
   * @param {Object} context module context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#contactUsModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method closeCallback
   * @returns {void}
   */
  closeCallback() {
    spartaUILayersUtility.closeLayer();
  }

  /**
   * @method openCallback
   * @returns {void}
   */
  openContactUsLayer() {
    $('#get_a_call_back_engagement').click();
  }

  /**
   * @method openGlobalFootersForMobile
   * @returns {void}
   */
  openGlobalFootersForMobile() {
    const $cache = $('#globalFooterModule .open-parent-accordion-on-small');
    // wait for footer to load so sleep for 1 sec
    setTimeout(() => {
      $cache.each((idx, val) => {
        const innerCache = $(val).closest('.column');
        // show list
        innerCache.find('.spa-toggle-heading-inner').show();
        // set arrow to the other way
        innerCache.find('.spa-toggle-arrow').addClass('active');
      });
    }, 1000);
  }

  /**
   * init for module JS.
   * @returns {void}
   */
  init() {
    this.$target.find('#get_call_back_link').on('click', this.openContactUsLayer);
    this.$target.find('#schedule-appt').attr('tabindex', 0);
    this.openGlobalFootersForMobile();
    const isEnglish = $('html').attr('lang') === 'es-US' ? false : true; // eslint-disable-line

    if (!isEnglish) {
      $('#locationNL').on('click', e => {
        e.preventDefault();
        setTimeout(() => {
          const url = 'https://homeloans.bankofamerica.com/locator/';
          $('#locationNLContinueLink').attr('href', url);
        }, 500);
      });
    } else {
      $('#locationNLEnglish').on('click', e => {
        e.preventDefault();
        const url = 'https://homeloans.bankofamerica.com/locator/';
        window.location.href = url;
      });
    }
    $('.removeElement').on('click', event => {
      $(event.currentTarget).closest('.child-container').remove();
    });

    // note: adding in below from 2.0.6 (was not picked up in development)
    const query = window.location.search;
    if (query == '?action=amp-modal') {
      // eslint-disable-line
      const module = this;
      this.Events.sub(this.settings.SPARTA_READY, () => {
        module.openContactUsLayer();
      });
    }
  }
}
registerModuleClass({
  moduleClass: contactUsModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { contactUsModule as default, moduleConfig };
